import React, { createContext, useContext, useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
// import * as actionsReconcile from '../../../_redux/reconcile/reconcileAction'
import * as reqDonatur from '../../../../Donatur/_redux/donatur/donaturCrud';
import * as reqReconcile from '../../../_redux/reconcile/reconcileCrud';
import { toast } from 'react-toastify';
import { toastOption } from '../../../../../../_metronic/_helpers';
import moment from 'moment'


const ReconcileEditUIContext = createContext();

export function useReconcileEditUIContext() {
    return useContext(ReconcileEditUIContext);
}

export const ReconcileEditUIConsumer = ReconcileEditUIContext.Consumer;

export function ReconcileEditUIProvider({ currentReconcileId, children, history, donationUIEvents }) {
    // get Reconcile Redux State
    const { currentState } = useSelector(
        (state) => ({ currentState: state.reconcile }),
        shallowEqual,
    );

    const { error } = currentState;

    const initDonatur = {
        uuid: undefined,
        donor_id: undefined,
        name: undefined,
        email: undefined,
        hp: undefined,
        address: undefined,
    };

    const [donatur, setDonatur] = useState(initDonatur);
    const [trxDate, setTrxDate] = useState(moment().format('YYYY-MM-DD'));
    const [triggerFetch, setTriggerFetch] = useState(false)

    // async function fetchSingleDonatur(reconcileId) {
    //     const resConfirm = await reqReconcile.getReconcileId(reconcileId)
    //     const resDonor = await reqDonatur.getDonaturById(resConfirm.data.data.donor_uuid);
    //     const { uuid, donor_id, name, email, hp, address } = resDonor.data.data;
    //     setDonatur({
    //         uuid: uuid,
    //         donor_id: donor_id,
    //         name: name,
    //         email: email,
    //         hp: hp,
    //         address: address,
    //     });
    //     setTrxDate(resConfirm.data.data.trf_date)
    // }


    useEffect(() => {

        if (error !== undefined) {
            toast.error(error, toastOption);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);

    useEffect(() => {
        // if (currentReconcileId) {

        //     fetchSingleDonatur(currentReconcileId);
        // } else {
        //     setDonatur(initDonatur);
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentReconcileId, triggerFetch])

    const [showDonatur, setShowDonatur] = useState(false);
    const [selectedReconcile, setSelectedReconcile] = useState({})

    const openDonatur = () => {
        setShowDonatur(true);
    };

    const closeDonatur = () => {
        setShowDonatur(false);
    };


    // PILIH DONATUR
    const donaturSelect = (data) => {
        setDonatur({
            uuid: data.uuid,
            donor_id: data.donor_id,
            name: data.name,
            email: data.email,
            hp: data.hp,
            address: data.address,
        });
        setShowDonatur(false);
    };

    // DATE INPUT
    const changeTrxDate = (event) => {
        setTrxDate(event.target.value);
    };

    const value = {
        showDonatur,
        openDonatur,
        closeDonatur,
        donaturSelect,
        openNewDonatur: donationUIEvents.newDonaturButtonClick,
        donatur,
        changeTrxDate,
        selectedReconcile,
        setSelectedReconcile,
        trxDate,
        setTriggerFetch
    }
    return (
        <ReconcileEditUIContext.Provider value={value}>
            {children}
        </ReconcileEditUIContext.Provider>
    );
}
